import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import api from "../../helper/api";
import { getServerURL } from "../../helper/envConfig";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function AIWhatDidYouLearn() {
    const { t } = useTranslation("WhatDidYouLearn");
    const serverURL = getServerURL();
    const location = useLocation();
    const [answer, setAnswer] = useState("");
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();


    const onSubmitAnswer = async () => {
        try {
            if (!answer.trim()) {
                toast.error(t("answer_required"));
                return;
            }
            setLoader(true);
            const response = await api.postWithToken(
                `${serverURL}trails/free-trails-chat-gpt-answer/`,
                {
                    name: location?.state?.name,
                    user_answer: answer,
                }
            );
            if (response.data.success) {
                setLoader(false);
                navigate("/free-trail/what-did-you-learn/certificate", {
                    state: {
                        grade: response.data.data.grade,
                        pdf: response.data.pdf_data || "",
                        trailId: location?.state?.trailId,
                        name: location?.state?.name,
                        userData: location?.state?.userData,
                    },
                });
            }
        } catch (error) {
            // console.log(error);
        }
    };

    useEffect(() => {
        if (!location?.state || !location?.state?.trailId) {
            navigate("/sign-in");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Header />
            <section className="py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="card border-0 question_card_box">
                                <div className="card-body">
                                    {/* //TODO: change title */}
                                    <h3>{t("whatdidyoulearn")} </h3>
                                    <img
                                        src="/new-business/question_card_box.webp"
                                        alt=""
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 ps-xl-5 question_card_details mt-4 mt-md-5 mt-lg-0">
                            <div className="position-relative">
                                {loader && (
                                    <div className="position-absolute top-50 start-50 translate-middle loader-spinner">
                                        <div
                                            className="spinner-border text-primary"
                                            role="status"
                                        ></div>
                                    </div>
                                )}
                                <h3>{t("data_privacy_reflection_question")}</h3>
                                <p>{t("grading_notice")}</p>

                                <textarea
                                    rows="10"
                                    className="form-control pt-2 mt-3 ai-textarea"
                                    placeholder={t("answer_prompt")}
                                    id="floatingTextarea2"
                                    value={answer}
                                    onChange={(e) => {
                                        setAnswer(e.target.value);
                                    }}
                                />

                                <div className="d-flex justify-content-end pt-4 pb-md-5">
                                    <button
                                        className="btn-explore p-sm-15 d-flex justify-content-between align-items-center gap-3 rounded-2 mt-md-4"
                                        onClick={onSubmitAnswer}
                                    >
                                        {t("proceed")}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={22}
                                            height={14}
                                            viewBox="0 0 22 14"
                                            fill="none"
                                            className="ms-5"
                                        >
                                            <path
                                                d="M1 6.99854H21L16 1"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21 6.99805L16 12.9995"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default AIWhatDidYouLearn;
